"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerAddressType = void 0;
var PartnerAddressType;
(function (PartnerAddressType) {
    PartnerAddressType["SHIP_TO"] = "shipTo";
    PartnerAddressType["BILL_TO"] = "billTo";
    PartnerAddressType["REMIT_TO"] = "remitTo";
    PartnerAddressType["MAIN"] = "Main(HQ)";
})(PartnerAddressType = exports.PartnerAddressType || (exports.PartnerAddressType = {}));
//# sourceMappingURL=partner-address-type.enum.js.map